export default __webpack_public_path__ + "static/media/Right_Arrow_Inactive.47843686.svg";